
import React from "react";

interface TabContentImageProps {
  src: string;
  alt: string;
  className?: string;
  allImagesLoaded: boolean;
}

export const TabContentImage: React.FC<TabContentImageProps> = ({
  src,
  alt,
  className = "object-cover rounded-image",
  allImagesLoaded
}) => (
  <img 
    src={src} 
    alt={alt} 
    className={className}
    style={{ opacity: allImagesLoaded ? 1 : 0.7 }}
  />
);

interface TabContentWithImageProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string;
  allImagesLoaded: boolean;
  imageClassName?: string;
}

export const TabContentWithImage: React.FC<TabContentWithImageProps> = ({
  imageSrc,
  imageAlt,
  title,
  description,
  allImagesLoaded,
  imageClassName = "w-70 h-70 object-cover grayscale mb-4 rounded-md"
}) => (
  <div className="flex flex-col items-center">
    <TabContentImage 
      src={imageSrc}
      alt={imageAlt}
      className={imageClassName}
      allImagesLoaded={allImagesLoaded}
    />
    <h3 className="text-lg font-medium mb-2 text-primary-dark">{title}</h3>
    <p className="text-sm text-primary-dark text-center">{description}</p>
  </div>
);

interface TabContentWithBreaksProps {
  imageSrc: string;
  imageAlt: string;
  title: string;
  description: string;
  allImagesLoaded: boolean;
}

export const TabContentWithBreaks: React.FC<TabContentWithBreaksProps> = ({
  imageSrc,
  imageAlt,
  title,
  description,
  allImagesLoaded
}) => (
  <div className="flex flex-col items-center">
    <br />
    <TabContentImage 
      src={imageSrc}
      alt={imageAlt}
      allImagesLoaded={allImagesLoaded}
    />
    <br />
    <h3 className="text-lg font-medium mb-2 text-primary-dark">{title}</h3>
    <p className="text-sm text-primary-dark text-center">{description}</p>
  </div>
);
